import React from 'react';
import PropTypes from 'prop-types';

import TextField from './TextField';
import emailValidator from '../../../helpers/validators/emailValidator';
import emailHinter from '../../../helpers/emailHinter';

export default class EmailField extends React.PureComponent {
    static propTypes = {
        /** html id required to connect the input with the label */
        id: PropTypes.string.isRequired,

        /** Label contents, usually text */
        label: PropTypes.node
    };

    static defaultProps = {
        label: 'Email'
    };

    textFieldRef = React.createRef();

    validate = () => {
        return this.textFieldRef.current.validate();
    }

    render() {
        const { id, label, ...rest } = this.props;

        return (
            <TextField
                ref={this.textFieldRef}
                id={id}
                type="email"
                label={label}
                validator={emailValidator}
                hinter={emailHinter}
                {...rest} />
        );
    }
}
